/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Submit = ({ color = 'tomato', size = 15, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14.973 14.973"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 282"
            d="M11.185-14.466l-1.009-1.089-1.941 1.818V-20h-1.5v6.263l-1.9-1.818-1.02 1.089 3.7 3.5zm3.788 9.439H0v-7.487h2.995v1.5H1.5v4.492h11.976v-4.492h-1.5v-1.5h2.995z"
            transform="translate(0 20)"
            fill={color}
            clipRule="evenodd"
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Path 281"
            d="M-356 2340.066H991.572V-537H-356z"
            transform="translate(356 537)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g data-name="Group 336">
        <g
          data-name="Group 335"
          transform="translate(0 20) translate(0 -20)"
          clipPath="url(#a)"
        >
          <g
            data-name="Group 334"
            transform="translate(-266.52 -387.053)"
            clipPath="url(#b)"
          >
            <path
              data-name="Path 280"
              d="M-5-25h22.46v22.46H-5z"
              transform="translate(267.777 408.309)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

Submit.propTypes = {
  color: string,
  size: number,
}

export default Submit
